import React, { FunctionComponent, useContext } from "react";
import { Switch, Route, Redirect, RouteProps, RouteComponentProps } from "react-router-dom";

import Dashboard from "../pages/Dashboard";
import UnitiesGroups from "../pages/UnitiesGroups";
import Login from "../pages/Login";
import ChangePassword from "../pages/Login/ChangePassword";
import ForecastUpdate from "../pages/ForecastUpdate";
import ForecastUnitDetails from "../pages/ForecastUpdate/UnitDetails";
import SalesUpdate from "../pages/SalesUpdate";
import SalesUnitDetails from "../pages/SalesUpdate/UnitDetails";
import CalendarManagement from "../pages/CalendarManagement";
import Profile from "../pages/Profile";
import Users from "../pages/Users";
import NotFound from "../pages/NotFound";
import Scoreboard from "../pages/Scoreboard";
import System from "../pages/System";
import AuthContext from "../contexts/AuthContext";
import TradeSalesRollBack from '../pages/TradeSalesRollBack';

interface PrivateRouteProps extends RouteProps {
    basic?: boolean;
    component: | React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
    redirectTo: string;
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ component: Component, redirectTo, basic, ...rest}) => {
  const { user, logged } = useContext(AuthContext);

  return (
    <Route {...rest}
      render={(props) => {
        return logged ? (!user!.basicLayout || user!.profile.name !== "Sender" || basic ? (
            <Component {...props} /> ) : (
            <NotFound />
            )) 
            : (<Redirect to={{ pathname: redirectTo, search: "?redirect_to=" + props.location.pathname, state: { from: props.location } }} /> );
      }}
    />
  );
};

const Routes = () => {
  const { user, logged } = useContext(AuthContext);
  const defaultPath: string = user ? user.basicLayout ? "/forecast-update" : "/dashboard" : "/login";
  return (
    <React.Fragment>
      <Switch>
        <PrivateRoute path="/calendar-management" redirectTo="/login" component={CalendarManagement} />
        <PrivateRoute basic={true} path="/forecast-update/:groupId/:currentYear/:monthId" redirectTo="/login" component={ForecastUnitDetails} />
        <PrivateRoute basic={true} path="/forecast-update" redirectTo="/login" component={ForecastUpdate} />
        <PrivateRoute basic={true} path="/sales-update/:groupId/:currentYear/:monthId" redirectTo="/login" component={SalesUnitDetails} />
        <PrivateRoute basic={true} path="/sales-update" redirectTo="/login" component={SalesUpdate} />
        <PrivateRoute path="/unities-groups" redirectTo="/login" component={UnitiesGroups} />
        <PrivateRoute path="/users" redirectTo="/login" component={Users} />
        <PrivateRoute basic={true}  path="/dashboard" redirectTo="/login" component={Dashboard} />
        <PrivateRoute path="/system" redirectTo="/" component={System} />
        <PrivateRoute basic={true} path="/profile" redirectTo="/login" component={Profile} />
        <Route exact path="/">
          <Redirect to={defaultPath} />
        </Route>
        <Route path="/login">
          {logged ? <Redirect to={defaultPath} /> : <Login />}
        </Route>
        {/* <Route path="/scoreboard" component={Scoreboard} /> */}
        <PrivateRoute basic={true} path="/scoreboard" redirectTo="/login" component={Scoreboard} />
        <Route path="/changepassword" component={ChangePassword} />
        <Route path="^\/[^\/api\/].*" component={NotFound} />
        <Route path="^\/[^\/saml\/].*" component={NotFound} />
        {/* <PrivateRoute path="/trade-sales-rollback" redirectTo="/login" component={TradeSalesRollBack} /> */}
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
